import DistributorLayout from '@/layouts/DistributorLayout.vue'
import PublicLayout from '@/layouts/PublicLayout.vue'

export default [
  {
    path: '/repair-files/create',
    name: 'repairFileCreate',
    component: () => import('@/views/restricted/repair-module/folder-setup/StepperFileView.vue'),
    props: (route) => ({
      repairFileBoomerangId:
        typeof route.query.repairFileBoomerangId === 'string'
          ? route.query.repairFileBoomerangId
          : undefined
    }),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_ADD_REPAIR_FILE'],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/repair-files/:repairFileBoomerangId/finalization',
    name: 'repairFileFinalization',
    component: () => import('@/views/restricted/repair-files/RepairFileFinalizationView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_ADD_REPAIR_FILE'],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/repair-files/:repairFileBoomerangId/shipping',
    name: 'repairFileShipping',
    component: () => import('@/views/restricted/repair-files/RepairFileShippingView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_ADD_REPAIR_FILE'],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/public/repair-prospect/add-product-picture',
    name: 'repairFileProspectAddPicture',
    component: () =>
      import('@/views/public-access/repair-module/RepairFileProspectAddPictureView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  },
  {
    path: '/public/repair-prospect/manufacturer-prospect-option-select',
    name: 'repairFileProspectManufacturerOptionSelected',
    component: () =>
      import(
        '@/views/public-access/repair-module/RepairFileProspectManufacturerOptionSelectedView.vue'
      ),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  }
]
